import React from 'react';

const TickIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
     <path d="M31 12L15.875 27.4L9 20.4" stroke="#149B32" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);

export default TickIcon;
